import React, { useCallback } from 'react';
import Modal from 'react-modal';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import { setPriceHistoryModalOpen } from '../../Actions/PriceHistory.actions';
import Icon from '../Icon';

const customModalStyles = {
  content: {
    background: 'none',
    padding: 0,
    border: 'none',
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.8)',
    zIndex: 2003,
  },
};

const PriceHistoryModal = () => {
  const {
    modalOpen,
    previouslyLowestPrice,
    numberOfDays,
    description,
    title,
  } = useTypedSelector((state) => state.priceHistory);

  const dispatch = useDispatch();

  const close = useCallback(() => {
    dispatch(
      setPriceHistoryModalOpen(
        false,
        previouslyLowestPrice,
        numberOfDays,
        description,
        title
      )
    );
  }, [dispatch, previouslyLowestPrice, numberOfDays, description, title]);

  return (
    <div id="price-history">
      <Modal
        ariaHideApp={false}
        preventScroll={true}
        isOpen={modalOpen}
        onRequestClose={close}
        style={customModalStyles}
        shouldCloseOnOverlayClick={true}
      >
        <div className="modalBox relative top-10 m-auto max-w-[640px] translate-y-[-50%] rounded border border-gray-300 bg-gray-100 p-7 lg:p-10 [&_.lowest-price]:mb-2">
          <div className="mb-2">
            <div
              className="absolute right-[5px] top-[5px] text-[1.5rem]"
              onClick={close}
            >
              <Icon
                className="absolute right-[5px] top-[5px] h-[14px] w-[14px] cursor-pointer text-gray-400"
                name="close"
                cursor="pointer"
              />
            </div>
            <h5 className="modal-title">{title}</h5>
            <h4 className="mb-2">{previouslyLowestPrice}</h4>
          </div>
          <div className="text-lg">
            <p>{description}</p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PriceHistoryModal;
